module.exports = __webpack_public_path__ + "static/bg-contact-4f58d6f852872b7f17c6b8df7cd54ce5.jpg";